import { assertErrors, fetchAPI, METHODS, parseBody } from './common';

/**
 * @typedef SmsBillingStatus
 * @property {boolean} hasBilling whether the team has an active Food Mover plan
 * @property {number} creditsUsed SMS credits used this billing period
 * @property {number} creditsIncluded credits included per period (e.g. 1000)
 * @property {number} remaining credits left this period
 * @property {string | null} currentPeriodStart
 * @property {string | null} currentPeriodEnd
 * @property {boolean} canBroadcast whether driver SMS broadcast is allowed now
 */

/** @returns {Promise<SmsBillingStatus>} */
export async function getStatus() {
  const res = await fetchAPI('/sms-billing/status', METHODS.get);
  await assertErrors(res);
  return parseBody(res);
}
